/* Compact info card replacing the previous voice-picker UI.
   The voice is now fixed to a British English female voice for reliability
   (too many of the previous gender/accent/age combinations failed silently
   across browsers, especially on iOS). */
import { SpeakerHigh } from "@phosphor-icons/react";

export default function VoicePicker({ compact = false }) {
  return (
    <div
      data-testid="voice-info"
      className={`flex items-center gap-3 rounded-xl bg-rf-cream/30 border border-rf-cream/20 ${compact ? "p-2.5 text-xs" : "p-3 text-sm"}`}
    >
      <div className="w-8 h-8 rounded-full bg-rf-amber/30 flex items-center justify-center text-rf-amber shrink-0">
        <SpeakerHigh size={16} weight="duotone" />
      </div>
      <div className="text-left text-rf-cream/85 leading-tight">
        <p className="font-bold text-rf-cream">British English voice</p>
        <p className="text-[11px] sm:text-xs opacity-80">Used for all reading &amp; voice replies in Kitchen View.</p>
      </div>
    </div>
  );
}
